/**
 * Budgets Tab — plan cards overview and alerts
 */

import React, { useState } from 'react';
import { BudgetOverview } from './BudgetOverview';
import { BudgetAlerts } from './BudgetAlerts';
import { BudgetDetailsModal } from './BudgetDetailsModal';
import { CreateBudgetModal } from './CreateBudgetModal';
import type { Budget } from '../../types/budget.types';

interface BudgetsTabProps {
  onDirtyChange?: (dirty: boolean) => void;
}

export function BudgetsTab({ onDirtyChange }: BudgetsTabProps): React.ReactElement {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [detailsBudget, setDetailsBudget] = useState<Budget | null>(null);
  const [editBudget, setEditBudget] = useState<Budget | null>(null);

  const handleCloseCreate = () => {
    onDirtyChange?.(false);
    setShowCreateModal(false);
    setEditBudget(null);
  };

  const modalOpen = showCreateModal || !!editBudget;

  return (
    <div className="space-y-6">
      <BudgetOverview
        onCreateBudget={() => setShowCreateModal(true)}
        onViewDetails={setDetailsBudget}
        onEdit={setEditBudget}
      />
      <BudgetAlerts />

      {detailsBudget && (
        <BudgetDetailsModal
          budget={detailsBudget}
          onClose={() => setDetailsBudget(null)}
        />
      )}

      {modalOpen && (
        <CreateBudgetModal
          budget={editBudget}
          onClose={handleCloseCreate}
          onDirtyChange={onDirtyChange}
        />
      )}
    </div>
  );
}
